import Page from "../../../../src/components/layouts/Page";
import { Link } from 'gatsby';
import SEO from "../../../../src/components/seo";
import React from 'react';
export default {
  Page,
  Link,
  SEO,
  React
};